import {ELEMENT_NOT_FOUND} from 'app/utils/Consts';
import LootInterface from 'app/interfaces/LootInterface';

export const lootItemMatches = (item: LootInterface, prize: LootInterface): boolean => {
    switch (true) {
    case Boolean(prize.steam_skin && item.steam_skin):
        return prize.steam_skin.id === item.steam_skin.id;
    case Boolean(prize.recipe && item.recipe):
        return prize.recipe.id === item.recipe.id;
    case Number(prize.points_amount) > 0:
        return Number(item.points_amount) === Number(prize.points_amount);
    case Number(prize.money_amount) > 0:
        return Number(item.money_amount) === Number(prize.money_amount);
    case Number(prize.frozen_money_amount) > 0:
        return Number(item.frozen_money_amount) === Number(prize.frozen_money_amount);
    case prize.bonus !== null && item.bonus !== null:
        return Number(item.bonus_amount) === Number(prize.bonus_amount);
    default:
        return false;
    }
};

export const lootIndexOfPrize = (loot: LootInterface[], prize?: LootInterface | null): number => {
    if (!prize) {
        return ELEMENT_NOT_FOUND;
    }

    return loot.findIndex((item: LootInterface) => lootItemMatches(item, prize));
};
